import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { SettingType } from '../../../models/setting-type';

import { AlertService } from '../../../services/common/alert.service';
import { SettingTypeService } from '../../../services/settings/setting-type.service';

@Component({
  selector: 'app-setting-type-form',
  templateUrl: './setting-type-form.component.html',
  styleUrls: ['./setting-type-form.component.css'],
})
export class SettingTypeFormComponent implements OnInit, OnChanges {
  formSubmitted: boolean = false;
  formSubmitting: boolean = false;

  @Input() setting_group_id: number;
  @Input() setting_type_id: number | undefined;
  @Output() formEvent: EventEmitter<string> = new EventEmitter();

  settingType: SettingType = new SettingType();

  constructor(private alertService: AlertService, private settingTypeService: SettingTypeService) {}

  ngOnInit() {
    if (!this.setting_type_id) {
      this.settingType = new SettingType();
      if (this.setting_group_id) this.settingType.setting_group_id = this.setting_group_id;
    } else this.settingTypeService.getSettingType(this.setting_type_id).then((response) => (this.settingType = response as SettingType));
  }

  ngOnChanges(changes: any) {
    if (changes.setting_group_id && changes.setting_group_id.currentValue && !this.setting_type_id) this.settingType.setting_group_id = this.setting_group_id;
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }

  fieldBuildErrorMessage(field: any, field_name: string): string {
    let error_message = [];
    let errors = field.errors || {};
    if (errors.required) error_message.push(field_name + ' is required');
    if (errors.notUnique) error_message.push(field_name + ' "' + field.value + '" is already taken');
    return error_message.join('<br />');
  }

  submitForm(formValid: any) {
    let scope: SettingTypeFormComponent = this;
    this.formSubmitted = true;
    if (formValid) {
      this.formSubmitting = true;
      if (this.settingType.id)
        this.settingTypeService
          .updateSettingType(this.settingType.setting_group_id, this.settingType.id, this.settingType)
          .then((response) => {
            this.formSubmitting = false;
            if (response && response.text) {
              this.alertService.alert_status_success(response.text);
              this.formEvent.emit('Setting Type updated');
            } else {
              this.alertService.alert_status_danger('Error updating setting type');
            }
          })
          .catch(function () {
            scope.formSubmitting = false;
            scope.alertService.alert_status_danger('Error updating setting type');
          });
      else
        this.settingTypeService
          .createSettingType(this.settingType.setting_group_id, this.settingType)
          .then((response) => {
            this.formSubmitting = false;
            if (response && response.text) {
              this.alertService.alert_status_success(response.text);
              this.formEvent.emit('Setting Type created');
            } else {
              this.alertService.alert_status_danger('Error creating setting type');
            }
          })
          .catch(function () {
            scope.formSubmitting = false;
            scope.alertService.alert_status_danger('Error creating setting type');
          });
    }
  }
}
